module.exports = __webpack_public_path__ + "img/caag1030_pdf.b18137e6.png";